import { useState } from "react";
import { Col, Row, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import "./jobGradeDefination.less";
import Table from "@components/Table";
import { handlePageChange, resetJobDetails } from "@/store/jobEvaluation";
import { useDispatch } from "react-redux";
import AddJobGradeDefination from "./AddJobGradeDefination";
import {
  useFetchAllGradePointsForCompaniesQuery,
  useFetchAllJobGradeMappingCompaniesQuery,
} from "@/services/jobGradeMapping";
import CustomButton from "@/components/customButton";
import SearchBox from "@/components/searchInput";
import CustomModal from "@/components/CustomModal";

const JobGradeDefination = () => {
  const [searchInput, setSearchInput] = useState("");

  const dispatch = useDispatch();
  const [isVisible, setIsVisible] = useState(false);
  const [page, setPage] = useState(1);
  // const [isModalOpen, setisModalOpen] = useState(false)
  // const [updatePayload, setupdatePayload] = useState({
  //   "company": 0,
  //   "grade_point_range": "",
  //   "grade_point_value": "",
  // })
  // const [updateBoxId, setupdateBoxId] = useState(null)

  const { data: JobGradeMappingCompaniesData } =
    useFetchAllJobGradeMappingCompaniesQuery(null);
  const { data } = JobGradeMappingCompaniesData || { data: [] };

  const {
    data: GradePointsForCompaniesData,
    isLoading: isLoadingGradePointsForCompanies,
  } = useFetchAllGradePointsForCompaniesQuery(null);
  const { data: gradePointsForCompany, pagination } =
    GradePointsForCompaniesData || { data: [] };

  const columns = [
    {
      title: "GRADE POINTS",
      key: "display_name",
      width: 200,
      align: "center",
      render: (record: any) => (
        <div className="text-wrap">{record.grade_point_range.display_name}</div>
      ),
    },
    ...data.map((eachCompany: { id: string; name: string }) => {
      return {
        title: eachCompany.name,
        key: eachCompany["id"].toString(),
        width: 200,
        align: "center",
        render: (record: any) => {
          return <div className="text-wrap">{record[eachCompany["id"]]}</div>;
        },
      };
    }),
    // {
    //   title: "Actions",
    //   key: "actions",
    //   width: 150,
    //   align: "center",
    //   // sorter: (a: IJobEvaluationDataResponse, b: IJobEvaluationDataResponse) => {
    //   //   const scoreA = a.evaluation_result || 0;
    //   //   const scoreB = b.evaluation_result || 0;
    //   //   return scoreA - scoreB;
    //   // },
    //   render: (record: any) => {

    //     return <div className="actions flex gap-2 items-center">
    //       <button
    //         //  onClick={() => {
    //         //   debouncedApiCallUpdate({
    //         //     "company": record?.[5],
    //         //     "grade_point_range": record?.grade_point_range?.key,
    //         //     "grade_point_value": record?.[6]
    //         //   },
    //         //     record?.grade_point_range?.id,
    //         //   )
    //         // }}

    //         onClick={() => {
    //           setupdatePayload({
    //             "company": record?.[5],
    //             "grade_point_range": record?.grade_point_range?.key,
    //             "grade_point_value": record?.[6]
    //           });
    //           setupdateBoxId(record?.grade_point_range?.id)
    //           setisModalOpen(true)
    //         }}
    //         className="bg-blue-400 rounded-sm text-xs text-white px-2 py-1 hover:bg-blue-500 transition-all">Update</button>
    //       <button onClick={() => debouncedApiCallDelete(record?.grade_point_range?.id, record?.grade_point_range?.id)} className="bg-red-400 rounded-sm text-xs text-white px-2 py-1 hover:bg-red-500 transition-all">Delete</button>
    //     </div>;
    //   },
    // },
  ];

  const onCloseModal = () => {
    setIsVisible(false);
  };

  return (
    <div className="bg-white h-full p-4">
      {isVisible && (
        <AddJobGradeDefination
          isVisible={isVisible}
          setIsVisible={onCloseModal}
        />
      )}

      {/* <div className="appTitle text-base font-[500] mx-5">
        Grade Definitions
      </div> */}

      <div className="jobCreationBar sticky top-0 z-10 bg-bgSidebar px-5 py-6 rounded-lg flex justify-between items-center mb-7">
        <div className="title uppercase text-white font-semibold text-2xl">
          JOB GRADE DEFINITION
        </div>

        <div className="flex gap-x-3">
          <CustomButton
            onClick={() => {
              dispatch(resetJobDetails);
              setIsVisible(true);
            }}
            btnName="Create / Update Grade Definitions"
            customClasses="shadow-lg"
          />
          <SearchBox
            placeholder="Type to search..."
            value={searchInput}
            onChange={value => setSearchInput(value)}
          />
        </div>
      </div>

      <div className="jobCreationListing bg-white py-4 rounded-lg">
        {/* <SearchBox
          placeholder="Type to search..."
          value={searchInput}
          onChange={value => setSearchInput(value)}
        /> */}
        <Table
          columns={columns}
          data={gradePointsForCompany}
          isLoading={isLoadingGradePointsForCompanies}
          pagination={true}
          count={pagination?.count}
          onChangePage={setPage}
          page={page}
          splitLastColumn={false}
        />
      </div>

      {/* <CustomModal footer={
        <>

          {
            !(isLoadingUpdateJobGradeMapping || isSuccessUpdateJobGradeMapping) &&

            <button
              disabled={updatePayload?.grade_point_value === ""} onClick={() => {

                debouncedApiCallUpdate(
                  { ...updatePayload },
                  updateBoxId,
                )
              }
              }
              className="bg-[#00519D] text-white rounded px-2 py-1">Update
            </button>
          }

          {isLoadingUpdateJobGradeMapping &&
            <button
              className="bg-[#00519D] text-white rounded px-2 py-1">Loading ...
            </button>
          }

          {isSuccessUpdateJobGradeMapping &&
            <button
              onClick={() => setisModalOpen(false)}
              className="bg-[#00519D] text-white rounded px-2 py-1">Close
            </button>
          }
        </>

      }
        title={"Update"} isVisible={isModalOpen} onClose={() => { setisModalOpen(false) }}>
        <div className="updateBox grid grid-cols-2 gap-2">

          <div className="flex flex-col space-y-1">
            <label className="text-sm font-medium text-gray-700">Company</label>
            <input
              disabled
              value={updatePayload?.company}
              type="text"
              className="bg-gray-200 rounded text-gray-400 px-2 py-1 border"
            />
          </div>

          <div className="flex flex-col space-y-1">
            <label className="text-sm font-medium text-gray-700">Grade Point Range</label>
            <input
              disabled
              value={updatePayload?.grade_point_range}
              type="text"
              className="bg-gray-200 rounded text-gray-400 px-2 py-1 border"
            />
          </div>

          <div className="flex flex-col space-y-1">
            <label className="text-sm font-medium text-gray-700">Grade Point Value</label>
            <input
              disabled={isSuccessUpdateJobGradeMapping}
              onChange={(e) => { setupdatePayload({ ...updatePayload, grade_point_value: e.target.value }) }}
              value={updatePayload?.grade_point_value}
              type="text"
              className={`bg-white rounded text-black px-2 py-1 border ${isSuccessUpdateJobGradeMapping && "!bg-gray-200 !text-gray-300"}`}
            />
          </div>

        </div>


      </CustomModal> */}
    </div>
  );
};

export default JobGradeDefination;
